import { StatesAndRegions } from './usStateAndRegionKeys';

export const US_STATES_BY_REGION = [
  { value: StatesAndRegions.Nationwide, label: 'Nationwide' },
  { value: StatesAndRegions.Northeast, label: 'Northeast' },
  { value: StatesAndRegions.Midwest, label: 'Midwest' },
  { value: StatesAndRegions.South, label: 'South' },
  { value: StatesAndRegions.West, label: 'West' },
  { value: StatesAndRegions.AL, label: 'Alabama' },
  { value: StatesAndRegions.AK, label: 'Alaska' },
  { value: StatesAndRegions.AZ, label: 'Arizona' },
  { value: StatesAndRegions.AR, label: 'Arkansas' },
  { value: StatesAndRegions.CA, label: 'California' },
  { value: StatesAndRegions.CO, label: 'Colorado' },
  { value: StatesAndRegions.CT, label: 'Connecticut' },
  { value: StatesAndRegions.DE, label: 'Delaware' },
  { value: StatesAndRegions.DC, label: 'District of Columbia (DC)' },
  { value: StatesAndRegions.FL, label: 'Florida' },
  { value: StatesAndRegions.GA, label: 'Georgia' },
  { value: StatesAndRegions.HI, label: 'Hawaii' },
  { value: StatesAndRegions.ID, label: 'Idaho' },
  { value: StatesAndRegions.IL, label: 'Illinois' },
  { value: StatesAndRegions.IN, label: 'Indiana' },
  { value: StatesAndRegions.IA, label: 'Iowa' },
  { value: StatesAndRegions.KS, label: 'Kansas' },
  { value: StatesAndRegions.KY, label: 'Kentucky' },
  { value: StatesAndRegions.LA, label: 'Louisiana' },
  { value: StatesAndRegions.ME, label: 'Maine' },
  { value: StatesAndRegions.MD, label: 'Maryland' },
  { value: StatesAndRegions.MA, label: 'Massachusetts' },
  { value: StatesAndRegions.MI, label: 'Michigan' },
  { value: StatesAndRegions.MN, label: 'Minnesota' },
  { value: StatesAndRegions.MS, label: 'Mississippi' },
  { value: StatesAndRegions.MO, label: 'Missouri' },
  { value: StatesAndRegions.MT, label: 'Montana' },
  { value: StatesAndRegions.NE, label: 'Nebraska' },
  { value: StatesAndRegions.NV, label: 'Nevada' },
  { value: StatesAndRegions.NH, label: 'New Hampshire' },
  { value: StatesAndRegions.NJ, label: 'New Jersey' },
  { value: StatesAndRegions.NM, label: 'New Mexico' },
  { value: StatesAndRegions.NY, label: 'New York' },
  { value: StatesAndRegions.NC, label: 'North Carolina' },
  { value: StatesAndRegions.ND, label: 'North Dakota' },
  { value: StatesAndRegions.OH, label: 'Ohio' },
  { value: StatesAndRegions.OK, label: 'Oklahoma' },
  { value: StatesAndRegions.OR, label: 'Oregon' },
  { value: StatesAndRegions.PA, label: 'Pennsylvania' },
  { value: StatesAndRegions.RI, label: 'Rhode Island' },
  { value: StatesAndRegions.SC, label: 'South Carolina' },
  { value: StatesAndRegions.SD, label: 'South Dakota' },
  { value: StatesAndRegions.TN, label: 'Tennessee' },
  { value: StatesAndRegions.TX, label: 'Texas' },
  { value: StatesAndRegions.UT, label: 'Utah' },
  { value: StatesAndRegions.VT, label: 'Vermont' },
  { value: StatesAndRegions.VA, label: 'Virginia' },
  { value: StatesAndRegions.WA, label: 'Washington' },
  { value: StatesAndRegions.WV, label: 'West Virginia' },
  { value: StatesAndRegions.WI, label: 'Wisconsin' },
  { value: StatesAndRegions.WY, label: 'Wyoming' }
];

export const REGION_STATES: { [key: string]: string[] } = {
  Nationwide: [
    ...['CT', 'ME', 'MA', 'NH', 'NJ', 'NY', 'PA', 'RI', 'VT'],
    ...['IL', 'IN', 'IA', 'KS', 'MI', 'MN', 'MO', 'NE', 'ND', 'OH', 'SD', 'WI'],
    ...['AL', 'AR', 'DE', 'FL', 'GA', 'KY', 'LA', 'MD', 'MS', 'NC', 'OK', 'SC', 'TN', 'TX', 'VA', 'WV'],
    ...['AK', 'AZ', 'CA', 'CO', 'HI', 'ID', 'MT', 'NV', 'NM', 'OR', 'UT', 'WA', 'WY']
  ],
  Northeast: ['CT', 'ME', 'MA', 'NH', 'NJ', 'NY', 'PA', 'RI', 'VT'],
  Midwest: ['IL', 'IN', 'IA', 'KS', 'MI', 'MN', 'MO', 'NE', 'ND', 'OH', 'SD', 'WI'],
  South: ['AL', 'AR', 'DE', 'FL', 'GA', 'KY', 'LA', 'MD', 'MS', 'NC', 'OK', 'SC', 'TN', 'TX', 'VA', 'WV'],
  West: ['AK', 'AZ', 'CA', 'CO', 'HI', 'ID', 'MT', 'NV', 'NM', 'OR', 'UT', 'WA', 'WY']
};
